import AppSelect from '@/components/ui/app-select';

import { BUDGET_FREQUENCIES, budgetLabel } from '@/utils/budget';

export default function BudgetFrequencyField({ value, onChange, className, labelClassName }: { value: string; onChange: (value: string) => void; className?: string; labelClassName?: string }) {
  return <div><label className={labelClassName}>Budget frequency</label><AppSelect aria-label="Budget frequency" className={className} value={value} onChange={(event) => onChange(event.target.value)}>{BUDGET_FREQUENCIES.map((frequency) => <option key={frequency} value={frequency}>{budgetLabel(frequency)}</option>)}</AppSelect></div>;
}
